export type ErrorContext = Record<string, boolean | number | string | null>;

export type ErrorAdapter = {
  capture(error: unknown, context?: ErrorContext): void;
};

class ConsoleErrorAdapter implements ErrorAdapter {
  public capture(error: unknown, context?: ErrorContext): void {
    console.error("[Internet Traffic Jam]", error, context ?? {});
  }
}

export const errors: ErrorAdapter = new ConsoleErrorAdapter();
